<template>
  <div v-show="show" class="load-icon-wrapper">
    <div class="load-icon"></div>
    <div class="load-hex"></div>
  </div>
</template>

<script>

  export default {
    name: "LoadIcon",
    components: {},
    props: {
      show: Boolean,
    },
    data() {
      return {}
    },
    computed: {},

    mixins: [],
    methods: {},
    mounted() {

    },
    created() {

    }
  }


</script>

<style lang="scss" scoped>

  .load-icon-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .load-icon {
    display: block;
    width: 100%;
    height: 100%;
    background-image: url("~@/assets/image/platform/loader/loader_buddy.svg");
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    animation: rotation 4s infinite linear;
    @keyframes rotation {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(359deg);
      }
    }
  }

  .load-hex {
    display: block;
    width: 100%;
    height: 100%;
    background-image: url("~@/assets/image/platform/loader/loader_hex.svg");
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    animation: hex 4s infinite linear;
    @keyframes hex {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(-359deg);
      }
    }
  }


</style>